<template>
  <div class="custom-documents">
    <div class="row mt-5">
      <div class="col text-center">
        <button class="btn btn-success btn-sm" @click="pricing">Learn More About Pricing</button>
      </div>
      <div class="col text-center">
        <button class="btn btn-success btn-sm" @click="agreement">License Agreement</button>
      </div>
    </div>
  </div>
  <z-tabs v-model="currentTab" :tabs="tabs" @change="setTab" />
  <div v-if="currentTab === 'Payment Service'" class="row p-3">
    <div class="col">
      <div v-if="isStripeCustomer">
        <LocationInvoices ref="invoices" />
      </div>
      <div v-else class="row">
        <div class="col">
          <span>Billable Account not established within the Stripe Payment Service</span>
          <br /><br />
          <span><b>NOTE:</b> those locations not using Invoices AI will <u>not</u> require a Stripe Account.</span>
        </div>
        <div class="col">
          <button v-if="isSuperAdmin" class="btn btn-primary btn-sm" @click="createCustomer">Create Account</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentTab === 'Transactions'" class="row p-3">
    <div class="row">
      <div class="col">
        <div class="input-group">
          <span class="input-group-text">Date Range</span>
          <input v-model="dateStart" type="date" name="dateStart" class="form-control custom-date" />
          <input v-model="dateEnd" type="date" name="dateEnd" class="form-control custom-date" />
          <button class="btn btn-primary btn-sm custom-space" @click="fetchTransactions">Refresh</button>
          <button v-if="transactions?.length" class="btn btn-success btn-sm custom-space" :disabled="isDownloading">Download</button>
          <button
            v-if="transactions?.length && isSuperAdmin"
            class="btn btn-primary btn-sm custom-space"
            :disabled="isCreatingInvoice"
            @click="createInvoiceStripe"
          >
            <FontAwesomeIcon v-if="isCreatingInvoice" icon="fa-solid fa-spinner" spin />
            Create Stripe Invoice
          </button>
          <button
            v-if="transactions?.length && isSuperAdmin"
            class="btn btn-primary btn-sm"
            :disable="isLoadingReport"
            @click="createInvoiceInternal"
          >
            <FontAwesomeIcon v-if="isLoadingReport" icon="fa-solid fa-spinner" spin />
            Create Internal Invoice
          </button>
          <div v-if="transactions?.length === 0" class="custom-none"></div>
        </div>
      </div>
      <div class="col-4"></div>
    </div>
    <div class="row mt-2">
      <div class="col custom-listing">
        <TransactionListing v-if="transactions?.length" ref="transactionListing" :transactions="transactions" />
      </div>
    </div>
  </div>
  <DialogPricing v-model="actionPricing" @closing="closeModal" />
  <DialogAgreement v-model="actionAgreement" @closing="closeModal" />
  <DialogPreview v-model="actionPreview" @closing="closeModal" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import { dashboardStore } from '@/stores/dashboard'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import TransactionListing from '@/components/dashboard/forms/TransactionListing.vue'
import LocationInvoices from './LocationInvoices.vue'
import DialogAgreement from '@/components/marketing/DialogAgreement.vue'
import DialogPricing from '@/components/marketing/DialogPricing.vue'
import DialogPreview from './DialogPreview.vue'
export default {
  name: 'LocationBilling',
  components: {
    FontAwesomeIcon,
    ZTabs,
    TransactionListing,
    LocationInvoices,
    DialogAgreement,
    DialogPricing,
    DialogPreview
  },
  data() {
    return {
      currentTab: 'Payment Service',
      viewing: 'customer',
      isCreatingInvoice: false,
      actionPricing: false,
      actionAgreement: false,
      isLoadingReport: false,
      actionPreview: null
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(locationStore, ['location', 'stripeInvoices']),
    ...mapState(dashboardStore, ['filterParams', 'transactions']),
    tabs() {
      let _tabs = ['Payment Service', 'Transactions']
      return _tabs
    },
    isSuperAdmin() {
      let _is = false
      if ([1].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isStripeCustomer() {
      let _is = false
      if (this.location.customerId) {
        _is = true
      }
      return _is
    },
    gotInvoices() {
      let _is = false
      if (this.stripeInvoices) {
        _is = true
      }
      return _is
    },
    dateStart: {
      get() {
        let _date = null
        if (this.filterParams) {
          _date = this.filterParams.startdate
        }
        return _date
      },
      set(value) {
        this.setFilter({
          name: 'startdate',
          value: value
        })
      }
    },
    dateEnd: {
      get() {
        let _date = null
        if (this.filterParams) {
          _date = this.filterParams.enddate
        }
        return _date
      },
      set(value) {
        this.setFilter({
          name: 'enddate',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions(dashboardStore, ['resetFilter', 'setFilter', 'resetTransactions', 'getTransactions']),
    ...mapActions(locationStore, ['createStripeCustomer', 'createStripeInvoice', 'createInvoice']),
    init() {
      this.clearFilter()
      this.isCreatingInvoice = false
      this.isLoadingReport = false
      this.actionPreview = null
      if (this.$refs.invoices) {
        this.$refs.invoices.getInvoices()
      }
    },
    setTab(tab) {
      this.currentTab = tab
      if (this.currentTab === 'Payment Service') {
        this.clearFilter()
        if (!this.gotInvoices && this.$refs.invoices) {
          this.$refs.invoices.getInvoices()
        }
      } else if (this.currentTab === 'Transactions') {
        this.clearFilter()
        this.setFilter({
          name: 'type',
          value: 'invoiceTransactions'
        })
        this.fetchTransactions()
      }
    },
    clearFilter() {
      this.resetFilter()
      this.resetTransactions()
      this.setFilter({
        name: 'firm',
        value: this.location.firm
      })
      this.setFilter({
        name: 'type',
        value: 'totalcount'
      })
    },
    closeModal() {
      this.actionPricing = null
      this.actionAgreement = null
      this.actionPreview = null
    },
    pricing() {
      this.actionPricing = {
        title: 'Invoices AI Pricing'
      }
    },
    agreement() {
      this.actionAgreement = {
        title: 'Software License Agreement'
      }
    },
    async fetchTransactions() {
      this.resetTransactions()
      await this.getTransactions(this.filterParams)
    },
    async createCustomer() {
      console.log('Create Customer')
      await this.createStripeCustomer(this.location.firm)
    },
    download() {
      this.$refs.transactionListing.download()
    },
    async createInvoiceStripe() {
      if (!this.isCreatingInvoice) {
        this.isCreatingInvoice = true
        let data = {
          dateStart: this.filterParams.startdate,
          dateEnd: this.filterParams.enddate,
          firm: this.location.firm
        }
        console.log('Create Stripe Invoice')
        await this.createStripeInvoice(data)
      }
      this.isCreatingInvoice = false
    },
    async createInvoiceInternal() {
      console.log('Create Invoice')
      if (!this.isLoadingReport) {
        this.actionPreview = null
        this.isLoadingReport = true
        let data = {
          dateStart: this.filterParams.startdate,
          dateEnd: this.filterParams.enddate,
          firm: this.location.firm,
          asBase64: true
        }
        console.log('View Invoice', data)
        let report = await this.createInvoice(data)
        if (report) {
          if (report.error) {
            alert('Failed to fetch PDF: ' + report.error)
          } else {
            const content = `data:application/pdf;base64,${report.pdf}`
            this.actionPreview = {
              title: 'Invoice',
              content: content,
              mimeType: 'application/pdf',
              height: '550px',
              size: 'modal-lg'
            }
          }
        }
        this.isLoadingReport = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-listing {
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 500px;
}
.custom-space {
  margin-right: 2px;
}
.custom-documents {
  position: absolute;
  top: 15px;
  right: 0;
  width: 400px;
  z-index: 1000;
}
.custom-none {
  width: 350px !important;
}
</style>
